export default __webpack_public_path__ + "static/media/vue.0bf16d5d.png";